import { Button, Card, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { BRAND } from "../../../shared/theme/brand";
import { TableCMS } from "./TableCMS";
import { useCMS } from "../hook";

export const CMS = () => {
  const { changeModalCMSState } = useCMS();

  return (
    <AdminMenuLayout pageDescription="CMS" title="CMS">
      <Card
        bodyStyle={{ padding: "24px", display: "block" }}
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            marginBottom: 24,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: 16,
          }}
        >
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              margin: 0,
              color: "#262626",
            }}
          >
            Contenidos CMS
          </h2>

          <Space size={12}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalCMSState}
              style={{
                borderRadius: "30px",
                fontWeight: 600,
                padding: "0 24px",
                height: 44,
                boxShadow: BRAND.primaryShadow,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              Nuevo contenido
            </Button>
          </Space>
        </div>

        <TableCMS />
      </Card>
    </AdminMenuLayout>
  );
};
